import { render, staticRenderFns } from "./waterfall-add.vue?vue&type=template&id=2dbd6f1f"
import script from "./waterfall-add.vue?vue&type=script&lang=js"
export * from "./waterfall-add.vue?vue&type=script&lang=js"
import style0 from "./waterfall-add.vue?vue&type=style&index=0&id=2dbd6f1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports